import defaultResources from '@m2h/assets/i18n/locales/resources';
import { mergeResources } from '@m2h/common/utils';
import { i18nClient as i18nClientSdk } from '@sailor/i18n-web';
import {
  getLocalSchemeData, mergeMachConfig2Window, replaceMachSchemeData2Window, updateMachObjectWithStore,
} from '@m2h/common/utils/machUtils';
import { restoreChannelIfMissing } from '@m2h/common/utils/channelContext';
import { requestConfig } from '../../request';

// 优先级： 1.实时计算值 > 2.url参数转化值 > 3.页面入口自定义初始化值 > 4.缓存值
// 优先级：3.页面入口自定义初始化值
export const pageInitConfig = (options: { i18nConfig?; i18nClient?; requestOption?; machConfig?; }) => {
  const {
    i18nConfig, i18nClient, requestOption, machConfig
  } = options;
  if (i18nConfig?.resources) {
    i18nConfig.resources = mergeResources(i18nConfig.resources, defaultResources);
  }
  // i18n配置
  i18nConfig && (i18nClient || i18nClientSdk).init(i18nConfig);
  // 请求配置
  requestOption && requestConfig(requestOption);

  // mach环境对象配置
  console.log('bundleName 优先级4 sparouter', window.Mach.env);
  // 优先级： 1.实时计算值 > 2.url参数转化值 > 3.页面入口自定义初始化值 > 4.缓存值
  // 优先级：4.缓存值，页面刷新时恢复数据(不包含路由跳转的存储)
  updateMachObjectWithStore();

  // 刷新加载时 | 路由回退时：读取localstorage中的data/schemeParams
  // 路由跳转的会传递页面对应值， 从路径对应存储获取
  // localstorage的数据主要为data 和 scheme, 切每次都传参，是否提前避免优先级过高？
  const localSchemeData = getLocalSchemeData() || {};
  replaceMachSchemeData2Window(localSchemeData);
  // 页面缓存可能整体替换 schemeParams；仅在目标页没有 channel 时恢复当前 Tab 的来源。
  restoreChannelIfMissing();
  // 顺序在replaceMachSchemeData2Window后，页面可覆盖任意(实时计算和url参数除外)的配置
  mergeMachConfig2Window(machConfig || {});

  console.log('bundleName 优先级', getLocalSchemeData());
  console.log('bundleName 优先级3 pageInitConfig', window.Mach.env);
};

export const Toast = {
  show(msg?: string, duration: number = 1, options?: any) {
    // Create toast container
    const toastContainer = document.createElement('div');
    toastContainer.style.cssText = `
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: rgba(0, 0, 0, 0.7);
      color: white;
      padding: 10px 20px;
      border-radius: 4px;
      z-index: 999999;
      text-align: center;
      pointer-events: auto;
    `;
    toastContainer.textContent = msg || '';

    // Create overlay to block clicks
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 999998;
      pointer-events: auto;
    `;
    document.body.appendChild(overlay);
    document.body.appendChild(toastContainer);

    // Remove after duration
    setTimeout(() => {
      document.body.removeChild(toastContainer);
      document.body.removeChild(overlay);
    }, duration * 1000);
  },
  hideLoading(params?) {
    console.log(params);
  },
};

export const Dialog = {
  show(
    options?: {
      title?: string;
      message?: string;
      leftButtonTitle?: string;
      rightButtonTitle?: string;
      level?: number;
    },
    callback?: (result: { which: number; }) => void
  ) {
    const dialogOptions = options || {};
    // 创建遮罩层
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999999;
    `;

    // 创建对话框
    const dialog = document.createElement('div');
    dialog.style.cssText = `
      width: 280px;
      background: white;
      border-radius: 12px;
      overflow: hidden;
    `;

    // 创建内容区
    const content = document.createElement('div');
    content.style.cssText = `
      padding: 20px 16px;
      text-align: center;
      font-size: 16px;
      color: #333;
      min-height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
    `;
    content.style.whiteSpace = 'pre-wrap';
    content.textContent = [dialogOptions.title, dialogOptions.message].filter(Boolean).join('\n');

    // 创建按钮容器
    const btnContainer = document.createElement('div');
    btnContainer.style.cssText = `
      display: flex;
      padding: 12px;
    `;

    // 创建按钮
    const createButton = (text: string, isRight: boolean) => {
      const btn = document.createElement('button');
      btn.style.cssText = `
        flex: 1;
        height: 40px;
        border: none;
        background: white;
        font-size: 16px;
        color: #000000;
        background-color: ${isRight ? '#FFE41F' : 'white'};
        font-weight: bold;
        border-radius: 24px;
        ${!isRight && dialogOptions.leftButtonTitle ? 'border: 1px solid #eee;' : ''}
        ${isRight && dialogOptions.rightButtonTitle && dialogOptions.leftButtonTitle ? 'margin-left: 10px;' : ''}
      `;
      btn.textContent = text;
      return btn;
    };

    // 添加按钮和事件监听
    if (dialogOptions.leftButtonTitle) {
      const leftBtn = createButton(dialogOptions.leftButtonTitle, false);
      leftBtn.onclick = () => {
        document.body.removeChild(overlay);
        callback?.({ which: -2 });
      };
      btnContainer.appendChild(leftBtn);
    }

    if (dialogOptions.rightButtonTitle) {
      const rightBtn = createButton(dialogOptions.rightButtonTitle, true);
      rightBtn.onclick = () => {
        document.body.removeChild(overlay);
        callback?.({ which: -1 });
      };
      btnContainer.appendChild(rightBtn);
    }

    if (!dialogOptions.leftButtonTitle && !dialogOptions.rightButtonTitle) {
      const confirmBtn = createButton('OK', true);
      confirmBtn.onclick = () => {
        document.body.removeChild(overlay);
        callback?.({ which: -1 });
      };
      btnContainer.appendChild(confirmBtn);
    }

    dialog.appendChild(content);
    dialog.appendChild(btnContainer);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);
  },
};
